import { render, staticRenderFns } from "./LanguageCommunication.vue?vue&type=template&id=96dbef10&scoped=true"
import script from "./LanguageCommunication.vue?vue&type=script&lang=ts"
export * from "./LanguageCommunication.vue?vue&type=script&lang=ts"
import style0 from "./LanguageCommunication.vue?vue&type=style&index=0&id=96dbef10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dbef10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96dbef10')) {
      api.createRecord('96dbef10', component.options)
    } else {
      api.reload('96dbef10', component.options)
    }
    module.hot.accept("./LanguageCommunication.vue?vue&type=template&id=96dbef10&scoped=true", function () {
      api.rerender('96dbef10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/ClientProfileSteps/LanguageCommunication.vue"
export default component.exports